"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var raf_1 = tslib_1.__importDefault(require("../utils/raf"));
var Tooltip_1 = tslib_1.__importDefault(require("../Tooltip"));
function SliderTooltip(props) {
    var visible = props.visible;
    var innerRef = react_1.useRef(null);
    react_1.useEffect(function () {
        var rafId = null;
        function keepAlign() {
            // 使用 window.requestAnimationFrame(callback)，在浏览器重绘前调用 tooltip 的强制对齐方法
            rafId = raf_1.default(function () {
                var _a;
                (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.forcePopupAlign();
                rafId = null;
                keepAlign();
            });
        }
        function cancelKeepAlign() {
            if (rafId != null) {
                raf_1.default.cancel(rafId);
            }
        }
        if (visible) {
            keepAlign();
        }
        return cancelKeepAlign;
    }, [visible]);
    return (react_1.default.createElement(Tooltip_1.default, tslib_1.__assign({ ref: innerRef }, props)));
}
exports.default = SliderTooltip;
//# sourceMappingURL=SliderTooltip.js.map